import { IGenericListItem } from '@/interfaces'

export class GenericListItem<T> implements IGenericListItem<T> {
	id: T
	description: string
	img: string | undefined
	message: string | undefined

	constructor(data: IGenericListItem<T>) {
		this.id = data.id
		this.description = data.description
		this.img = data.img
		this.message = data.message
	}
}
